/**
 * Shared formatting helpers for the Self-Schedule / Job Preview screens.
 */

/**
 * Formats a US 10-digit phone number as "(XXX) XXX-XXXX".
 *
 * Strips all non-digit characters first, then formats only when the result is
 * exactly 10 digits (optionally with a leading US country code "1"). For any
 * other input the original trimmed value is returned unchanged, so
 * non-US / differently-formatted numbers are never silently garbled.
 *
 * @param {string} phone raw phone value
 * @returns {string} formatted phone or the original trimmed value
 */
export const formatPhoneNumber = (phone) => {
	if (!phone) {
		return '';
	}
	const trimmed = String(phone).trim();
	let digits = trimmed.replace(/\D/g, '');
	// Drop a leading US country code if present (11 digits starting with 1).
	if (digits.length === 11 && digits.startsWith('1')) {
		digits = digits.slice(1);
	}
	if (digits.length !== 10) {
		return trimmed;
	}
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/**
 * Resolves the store display label, preferring "Walmart Store #<nbr>" when a
 * store number is available and falling back to the raw store name.
 *
 * @param {object} params
 * @param {string|number} params.storeNbr store number
 * @param {string} params.storeName fallback store name
 * @param {Function} params.t i18next translate fn
 * @returns {string} store display label
 */
export const resolveStoreName = ({ storeNbr, storeName, t }) => {
	if (storeNbr) {
		return t('selfSchedule.walmartStoreNumber', { storeNbr });
	}
	return storeName || '';
};
